// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"489cb9b8","466":"4a2e463c","546":"ded9f789"}[chunkId] + ".chunk.js";
};